import {
    PERFORMANCE_TABLE_NUMERIC_COLUMNS,
    PERFORMANCE_TABLE_CURRENCY_COLUMNS,
    PERFORMANCE_TABLE_PERCENTAGE_COLUMNS,
    GREEN_HEX_CODE,
    RED_HEX_CODE
} from "@/constants/constants";

const colorList = [
    '#FF4C4C', // Red
    '#4C9BFF', // Blue
    '#4CD7D0', // Teal
    '#F4B400', // Yellow
    '#A07BFF', // Purple
    '#00C49F', // Green
    '#FFBB28'  // Orange
  ]

function build_table_header_name(raw_header){
    let header = [];
    raw_header.forEach((item) => {
        header.push(item.text)
    })
    return header
}

function build_table_header_value(raw_header){
    let header = [];
    raw_header.forEach((item) => {
        header.push(item.value)
    })
    return header
}

function build_table_body(raw_body, header, set_row_color = false){
    let statistics_data = [];
    raw_body.forEach((raw_row, row_idx) => {
        let row = [];
        let cell_value = '';
        header.forEach((column, col_idx) => {
            if(PERFORMANCE_TABLE_NUMERIC_COLUMNS.includes(column)){
                cell_value = raw_row[column]
                    ? raw_row[column].toLocaleString("en-CA", {
                        minimumFractionDigits: 0, 
                        maximumFractionDigits: 0,
                    })
                    : "n/a"
                if(column.includes('change') && raw_row[column]) {
                    cell_value = {
                        text: cell_value,
                        options: { color: raw_row[column] > 0 ? GREEN_HEX_CODE : RED_HEX_CODE }
                    }
                }
            } else if(PERFORMANCE_TABLE_CURRENCY_COLUMNS.includes(column)){
                cell_value = raw_row[column]
                    ? raw_row[column].toLocaleString("en-CA", {
                        style: "currency",
                        currency: "CAD",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    })
                    : "n/a"
                
                if(column.includes('change') && raw_row[column]) {
                    cell_value = {
                        text: cell_value,
                        options: { color: raw_row[column] > 0 ? GREEN_HEX_CODE : RED_HEX_CODE }
                    }
                }
            } else if(PERFORMANCE_TABLE_PERCENTAGE_COLUMNS.includes(column)){
                cell_value = raw_row[column]
                    ? raw_row[column].toLocaleString("en-CA", {
                        style: "percent",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    })
                    : "n/a"

                if(column.includes('change') && raw_row[column]) {
                    cell_value = {
                        text: cell_value,
                        options: { color: raw_row[column] > 0 ? GREEN_HEX_CODE : RED_HEX_CODE }
                    }
                }
            } 
            else if(column.toLowerCase().includes('change') && raw_row[column]) {
                cell_value = raw_row[column]
                    ? raw_row[column].toLocaleString("en-CA", {
                        style: "percent",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    })
                    : "n/a"
                cell_value = {
                    text: cell_value,
                    options: { color: raw_row[column] > 0 ? GREEN_HEX_CODE : RED_HEX_CODE }
                }
            }
            else if(set_row_color && col_idx === 0) {
                cell_value = {
                    text: raw_row[column] ? raw_row[column].toString() : "n/a",
                    options: { bold: true, color: colorList[row_idx] }
                }
            }
            else {
                cell_value = raw_row[column] ? raw_row[column] : "n/a"
            }
            row.push(cell_value)
        })
        statistics_data.push(row);
    })
    return statistics_data
}

function format_number(number){
    return number.toLocaleString();
}

function format_percentage(stat){
    if(stat == 0 || stat === '-' || stat == null){
        return "-"
    }
    return (stat * 100).toLocaleString("en-CA",{minimumFractionDigits: 0, maximumFractionDigits: 0, notation: 'compact'}) + "%"
}
 
function format_spend(stat){
    if(stat == 0 || stat === '-'){
        return "-"
    }
    return stat.toLocaleString("en-CA",{style: "currency", currency: "CAD",  minimumFractionDigits: 1, maximumFractionDigits: 1, notation: 'compact'})
}

export {build_table_header_name, build_table_header_value, build_table_body, format_number, format_percentage, format_spend}